import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@material-ui/core';
import { useStyles } from './styles';
import { DepartmentTable } from 'components/Tables/DepartmentTable/DepartmentTable';

const DepartmentsTable: FC = observer(() => {
  const classes = useStyles();
  return (
    <Container maxWidth='xl' className={classes.container}>
      <DepartmentTable />
    </Container>
  );
});

export default DepartmentsTable;
